let runningIndex = 1;
export default function uniqueId(prefix?: string) {
  const output = `${prefix || ''}${runningIndex}`;
  runningIndex += 1;
  return output;
}
